import React, { useState, useEffect, Fragment } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import localization from 'assets/localization/localization';
import { FormGroup } from 'react-bootstrap';

const List = [
  { name: 'Yes', id: 0 },
  { name: 'No', id: 1 },
];

const ParkingDetails = ({ data, handleValue, imageUploadUrl }) => {
  const parkingDetail = {
    parkingChargeType: '',
    twoParkingHour: '',
    twoProgressiveRatePerHr: '',
    fourParkingHour: '',
    fourWheelParkingRatePerhour: '',
    twoWheelParkingRatePerhour: '',
    fourProgressiveRatePerHr: '',
    parkingManagementCompany: '',
    parkingEquipmentManufacturer: '',
    slotsSensor: '',
    stackParking: '',
    parkingEquipmentRemark: '',
    otherLocationPresent: '',
  };

  const [parkingData, setParkingData] = useState(parkingDetail);
  const [files, setFiles] = useState([]);
  const [Exterior, setExterior] = useState([]);
  const [approach_road, setApproach_road] = useState([]);
  const [parking_area, setParking_area] = useState([]);
  const [parkingChargeList, setparkingChargeList] = useState();

  useEffect(() => {
    if (data) {
      setparkingChargeList(data.parkingChargesType);
    }
  }, [data]);

  const handleFormData = () => {
    let two_wheeler = [
      {
        no_of_hours: parkingData.twoParkingHour,
        parking_charges: parkingData.twoWheelParkingRatePerhour,
        progressive_rate_per_hour: parkingData.twoProgressiveRatePerHr,
      },
    ];
    let four_wheeler = [
      {
        no_of_hours: parkingData.fourParkingHour,
        parking_charges: parkingData.fourWheelParkingRatePerhour,
        progressive_rate_per_hour: parkingData.fourProgressiveRatePerHr,
      },
    ];

    if (parkingData.parkingChargeType !== '') {
      handleValue({
        parking_type: parkingData.parkingChargeType,
        'two-wheeler': two_wheeler,
        'four-wheeler': four_wheeler,
        slot_sensor: parkingData.slotsSensor,
        stack_parking: parkingData.stackParking,
        parking_management_company: parkingData.parkingManagementCompany,
        parking_equipment_manufacturer:
          parkingData.parkingEquipmentManufacturer,
        parking_equipment_remarks: parkingData.parkingEquipmentManufacturer,
        other_location_present: parkingData.otherLocationPresent,
        photos: [
          {
            Exterior: Exterior,
            parking_area: parking_area,
            approach_road: approach_road,
          },
        ],
      });
    } else handleValue(null);
  };

  useEffect(() => {
    handleFormData();
  }, [parkingData, Exterior, approach_road, parking_area]);

  return (
    <FormSection title={localization.parkingDetailsTitle}>
      <DropDownInput
        label={localization.parkingChargesType}
        data={data && data.parkingChargesType}
        required
        isStarRequired={true}
        errorMsg={localization.requiredParkingCharges}
        getIdValue={(val) =>
          setParkingData({ ...parkingData, parkingChargeType: val.id })
        }
      />
      {(parkingData.parkingChargeType === 2 ||
        parkingData.parkingChargeType === 1) && (
        <>
          <div className="full-width">
            <label className="label">Parking Charges - Two Wheelers</label>
            {parkingData.parkingChargeType === 'Flat' && (
              <div className="full-width">
                <ConstantInput
                  label={localization.fixedParkingRates}
                  regex={Regex.decimalNum.test(
                    parkingData.twoWheelParkingRatePerhour
                  )}
                  errorMsg={
                    parkingData.twoWheelParkingRatePerhour
                      ? localization.requiredDecimal
                      : localization.requiredParkingRate
                  }
                  className="indianrupee"
                  type="text"
                  isPrefix
                  prefixText={'₹'}
                  handleChange={(val) => {
                    setParkingData({
                      ...parkingData,
                      twoWheelParkingRatePerhour: val,
                    });
                  }}
                  required
                  isStarRequired={true}
                />
              </div>
            )}

            {parkingData.parkingChargeType === 'Progressive' && (
              <Fragment>
                <div className="full-width">
                  <ConstantInput
                    label={localization.parkingHour}
                    regex={Regex.decimalNum.test(parkingData.twoParkingHour)}
                    errorMsg={localization.numericErrorMg}
                    type="text"
                    handleChange={(val) => {
                      setParkingData({
                        ...parkingData,
                        twoParkingHour: val,
                      });
                    }}
                    required
                    isStarRequired={true}
                  />

                  <ConstantInput
                    label={localization.parkingRate}
                    regex={Regex.decimalNum.test(
                      parkingData.twoWheelParkingRatePerhour
                    )}
                    errorMsg={localization.numericErrorMg}
                    type="text"
                    className="indianrupee"
                    type="text"
                    isPrefix
                    prefixText={'₹'}
                    handleChange={(val) => {
                      setParkingData({
                        ...parkingData,
                        twoWheelParkingRatePerhour: val,
                      });
                    }}
                    required
                    isStarRequired={true}
                  />

                  <ConstantInput
                    label={localization.progressiveRatePerHour}
                    regex={Regex.decimalNum.test(
                      parkingData.twoProgressiveRatePerHr
                    )}
                    errorMsg={localization.numericErrorMg}
                    type="text"
                    className="indianrupee"
                    type="text"
                    isPrefix
                    prefixText={'₹'}
                    handleChange={(val) => {
                      setParkingData({
                        ...parkingData,
                        twoProgressiveRatePerHr: val,
                      });
                    }}
                    required
                    isStarRequired={true}
                  />
                </div>
              </Fragment>
            )}
          </div>

          <div className="full-width">
            <label className="label">Parking Charges - Four Wheelers</label>
            {parkingData.parkingChargeType === 'Flat' && (
              <div className="full-width">
                <ConstantInput
                  label={localization.fixedParkingRates}
                  regex={Regex.decimalNum.test(
                    parkingData.fourWheelParkingRatePerhour
                  )}
                  errorMsg={
                    parkingData.fourWheelParkingRatePerhour
                      ? localization.requiredDecimal
                      : localization.requiredParkingRate
                  }
                  className="indianrupee"
                  type="text"
                  isPrefix
                  prefixText={'₹'}
                  handleChange={(val) => {
                    setParkingData({
                      ...parkingData,
                      fourWheelParkingRatePerhour: val,
                    });
                  }}
                  required
                  isStarRequired={true}
                />
              </div>
            )}

            {parkingData.parkingChargeType === 'Progressive' && (
              <Fragment>
                <div className="full-width">
                  <ConstantInput
                    label={localization.parkingHour}
                    regex={Regex.decimalNum.test(parkingData.fourParkingHour)}
                    errorMsg={localization.numericErrorMg}
                    type="text"
                    handleChange={(val) => {
                      setParkingData({
                        ...parkingData,
                        fourParkingHour: val,
                      });
                    }}
                    required
                    isStarRequired={true}
                  />

                  <ConstantInput
                    label={localization.parkingRate}
                    regex={Regex.decimalNum.test(
                      parkingData.fourWheelParkingRatePerhour
                    )}
                    errorMsg={localization.numericErrorMg}
                    type="text"
                    className="indianrupee"
                    isPrefix
                    prefixText={'₹'}
                    handleChange={(val) => {
                      setParkingData({
                        ...parkingData,
                        fourWheelParkingRatePerhour: val,
                      });
                    }}
                    required
                    isStarRequired={true}
                  />

                  <ConstantInput
                    label={localization.progressiveRatePerHour}
                    regex={Regex.decimalNum.test(
                      parkingData.fourProgressiveRatePerHr
                    )}
                    errorMsg={localization.numericErrorMg}
                    type="text"
                    className="indianrupee"
                    isPrefix
                    prefixText={'₹'}
                    handleChange={(val) => {
                      setParkingData({
                        ...parkingData,
                        fourProgressiveRatePerHr: val,
                      });
                    }}
                    required
                    isStarRequired={true}
                  />
                </div>
              </Fragment>
            )}
          </div>
        </>
      )}

      <hr />

      <ConstantInput
        label={localization.parkingManagementCompany}
        regex={Regex.charSpace.test(parkingData.parkingManagementCompany)}
        type="text"
        handleChange={(val) => {
          setParkingData({
            ...parkingData,
            parkingManagementCompany: val,
          });
        }}
        required
        isStarRequired={true}
      />

      <ConstantInput
        label={localization.parkingEquipmentManufacture}
        regex={Regex.charSpace.test(parkingData.parkingEquipmentManufacturer)}
        type="text"
        handleChange={(val) => {
          setParkingData({
            ...parkingData,
            parkingEquipmentManufacturer: val,
          });
        }}
        required
        isStarRequired={true}
      />

      <DropDownInput
        label={localization.slotSensor}
        data={List}
        required
        isStarRequired={true}
        errorMsg={localization.requiredSlotSensor}
        getIdValue={(val) => {
          setParkingData({
            ...parkingData,
            slotsSensor: val.id,
          });
        }}
      />

      <DropDownInput
        label={localization.stackParking}
        data={List}
        required
        isStarRequired={true}
        errorMsg={localization.requiredStackparking}
        getIdValue={(val) => {
          setParkingData({
            ...parkingData,
            stackParking: val.id,
          });
        }}
      />

      <ConstantInput
        label={localization.parkingEquipmentRemark}
        regex={Regex.charSpace.test(parkingData.parkingEquipmentRemark)}
        errorMsg={
          parkingData.parkingEquipmentRemark
            ? localization.alphaErrorMg
            : localization.requiredParkingEquipmentRemark
        }
        type="text"
        handleChange={(val) => {
          setParkingData({
            ...parkingData,
            parkingEquipmentRemark: val,
          });
        }}
        required
        isStarRequired={true}
      />

      <ConstantInput
        label={localization.otherLocationPresent}
        regex={Regex.charSpace.test(parkingData.otherLocationPresent)}
        errorMsg={
          parkingData.otherLocationPresent
            ? localization.alphaErrorMg
            : localization.requiredOtherLocation
        }
        type="text"
        handleChange={(val) => {
          setParkingData({
            ...parkingData,
            otherLocationPresent: val,
          });
        }}
        required
        isStarRequired={true}
      />

      <div className="w-100">
        <div className="btn-transparent mr-3 d-inline-block">
          <FileUpload
            documentUploadUrl={imageUploadUrl}
            multiple
            id="exterior"
            accept=".png, .jpg"
            onChange={(val) => {
              setExterior(val.toString());
            }}
          >
            <span className="btn btn-transparent">{localization.exterior}</span>
          </FileUpload>

          <label
            className={`error ${Exterior.length < 0 ? '' : 'error-block'}`}
          >
            {localization.exteriorUploadPhotoRequired}
          </label>
        </div>
        <div className="btn-transparent mr-3 d-inline-block">
          <FileUpload
            accept=".png, .jpg"
            documentUploadUrl={imageUploadUrl}
            multiple
            id="parkingArea"
            onChange={(val) => setParking_area(val.toString())}
          >
            <span className="btn btn-transparent">
              {localization.parkingArea}
            </span>
          </FileUpload>
          <label
            className={`error ${parking_area.length < 0 ? '' : 'error-block'}`}
          >
            {localization.parkingAreaUploadPhotoRequired}
          </label>
        </div>
        <div className="btn-transparent mr-3 d-inline-block">
          <FileUpload
            accept=".png, .jpg"
            documentUploadUrl={imageUploadUrl}
            multiple
            id="appraochRoad"
            onChange={(val) => setApproach_road(val.toString())}
          >
            <span className="btn btn-transparent">
              {localization.appraochRoad}
            </span>
          </FileUpload>
          <label
            className={`error ${approach_road.length < 0 ? '' : 'error-block'}`}
          >
            {localization.approachRoadUploadPhotoRequired}
          </label>
        </div>
      </div>
    </FormSection>
  );
};

export default ParkingDetails;
